module.exports = __webpack_public_path__ + "img/b4f85dc.jpg";